import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter, Redirect } from "react-router"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Loading from 'components/Loading'
import Block from 'components/common/Block'
import ResultBlock from 'components/common/ResultBlock'
import CreateOrderResultDialog from './CreateOrderResultDialog'

import {
	formatNumber, formatDate,
	receiptTypeEnum, shippingTypeEnum, shippingUrgencyEnum,
	shippingTimeSessionEnum,
} from 'libraries/utils'

import {
	createShippingOrder,
	orderCreditCardPayment,
} from '../../actions/asyncOrders'

import {
	cleanOrderCreditCardPaymentResult
} from '../../actions/orders'

const ListFiedGrid = props => (
	<Grid container className="list-item">
		<Grid item xs={2}>
			<Typography className="text-grey">{props.title}</Typography>
		</Grid>
		<Grid item xs={10}>
			{props.children}
		</Grid>
	</Grid>
)

function getShippingTime (data) {
	if(!data) return {};
	const str = data.split(' ')
	let shippingTime = str[1]
	if(shippingTimeSessionEnum[str[1]]){
		shippingTime = shippingTimeSessionEnum[str[1]]
	}
	return {
		shippingData: formatDate(str[0]),
		shippingTime
	}
}

const PaymentComfirm = props => {
	const { t } = useTranslation();
	const { isLoading, shippingCart, memberInfo,
		shippingOrderData,
		orderCreditCardPaymentSucc, orderCreditCardPaymentFail,
		cleanOrderCreditCardPaymentResult,
		createShippingOrderFail,
		errorCode,
	} = props
	const [paymentResult, setPaymentResult] = useState(null)
 	const [createOrderDialog, setCreateOrderDialog] = useState(false)

	const { shippingData, shippingTime } = getShippingTime(shippingOrderData.get('shippingTime'))
	const receiptType = shippingOrderData.get('receiptType')

	const storageOrderItems = shippingCart.get('list').reduce((acc, curr) => {
		return acc.concat(curr.get('storageOrderItems').toJS())
	}, [])

	const onCloseDialog = () => {
		setCreateOrderDialog(false)
	}

	const goBack = () => {
		props.history.push('/member/shippingcart')
	}

	const onConfirm = () => {
		// create shipping order then payment
		const { total, selectedCoupon, ccLastFour, ...param } = shippingOrderData.toJS()
		const query = {
			...param
		}
		props.createShippingOrder(query, total > 0)
	}

	const goOrderList = () => {
		props.history.push('/member/order')
	}

	useEffect(() => {
		if(orderCreditCardPaymentSucc) {
			setPaymentResult('succ')
		}
		if(orderCreditCardPaymentFail) {
			setPaymentResult('fail')
		}
		return () => {
			cleanOrderCreditCardPaymentResult()
		}
	}, [orderCreditCardPaymentSucc, orderCreditCardPaymentFail])

	useEffect(() => {
		if(!!createShippingOrderFail){
			setCreateOrderDialog(true)
		}
	}, [createShippingOrderFail])

	if(paymentResult === 'succ') {
		return (
				<Grid container justify="center" style={{ marginTop: '20vh' }}>
					<ResultBlock
						status="succ"
						onClick={goOrderList}
						title={t('payment_status_paid')}
						msg={''}
					/>
				</Grid>
			)
	}

	if(paymentResult === 'fail'){
		return (
			<Grid container justify="center" style={{ marginTop: '20vh' }}>
				<ResultBlock
					onClick={goOrderList}
					title={t('patment_status_failed')}
					msg={'出了一點差錯，別擔心！<br/>稍後您可以從訂單記錄中重新付款'}
				/>
			</Grid>
		)
	}

	if(shippingOrderData.size === 0) {
		return (<Redirect to="/member/shippingcart" />)
	}

	return (
		<Grid item container justify="center" className="main-contaienr payment-comfirm">
			<Loading isLoading={isLoading} />
			<Grid item md={8}>
				<Grid container>
					<Typography variant="h1">
						{t('outbound_fee_comfirm')}
					</Typography>
				</Grid>

				{/* 物流資訊 */}
				<Block
					title={t('shipping_info')}
					contClassname="bg-white shipping-detail"
				>
					<ListFiedGrid title={t('picker_name')}>
						{shippingOrderData.get('name')}
					</ListFiedGrid>
					<ListFiedGrid title={t('picker_tel')}>
						{shippingOrderData.get('phone')}
					</ListFiedGrid>
					<ListFiedGrid title={'寄送方式'}>
						{shippingTypeEnum[shippingOrderData.get('shippingType')]}
					</ListFiedGrid>
					<ListFiedGrid title={t('pick_up_location')}>
						{shippingOrderData.get('shippingType') === shippingTypeEnum.STORE_PICK_UP ?
							<div>
                <Typography>
                    CellWine實體酒窖
                </Typography>
                <Typography className="text-grey"
                    style={{ fontWeight: 500, marginTop: '5px' }}
                >
                    台北市大安區新生南路二段2號B1 <br />
                    02-23222885 <br />
                    10:00~18:00 (Mon~ Fri)
                </Typography>
            	</div>
							:
							`${shippingOrderData.get('city')}${shippingOrderData.get('area')}${shippingOrderData.get('address')}`
						}
					</ListFiedGrid>
					<ListFiedGrid title={t('pick_up_time')}>
						{shippingData} {shippingTime} {`(${shippingUrgencyEnum[shippingOrderData.get('shippingUrgency')]})`}
					</ListFiedGrid>
					<ListFiedGrid title={t('remark')}>
						{shippingOrderData.get('message')}
					</ListFiedGrid>
				</Block>

				{/* 帳單資訊 */}
				<Block
					title={t('credit_card_setting')}
					contClassname="bg-white payment-detail"
				>
					<ListFiedGrid
						title={t('receipt_info')}
					>
						<Typography>{receiptTypeEnum[receiptType]}</Typography>
						{receiptType.toString() === receiptTypeEnum.THREE_LINE &&
							<Grid>
								<Typography className="text-grey">
									{t('receipt_title')}：{shippingOrderData.get('receiptTitle')}
								</Typography>
								<Typography className="text-grey">
									{t('tax_id')}：{shippingOrderData.get('receiptTaxId')}
								</Typography>
							</Grid>
						}
					</ListFiedGrid>
					<ListFiedGrid
						title={t('payment_method')}
					>
						<Typography>
							{t('credit_card')} ···· ···· ···· {memberInfo.creditCardLastFour}
						</Typography>
					</ListFiedGrid>
					<ListFiedGrid
						title={t('shipping_items')}
					>
						<Typography>{shippingOrderData.get('storageOrderItem').size} {t('bottle')}</Typography>
					</ListFiedGrid>
					{shippingOrderData.get('selectedCoupon').size > 0 &&
						<ListFiedGrid
							title={t('use_coupon')}
						>
							<Typography>
								<span style={{ fontWeight: '500'}}>{shippingOrderData.getIn(['selectedCoupon', 'name'])}</span> － {shippingOrderData.getIn(['selectedCoupon', 'couponType'])}
							</Typography>
							<Typography className="text-grey">
								{shippingOrderData.getIn(['selectedCoupon', 'description'])}
							</Typography>
						</ListFiedGrid>
					}
					<ListFiedGrid
						title={t('total_fee')}
					>
						<Typography color="primary" variant="h1">
							{formatNumber(shippingOrderData.get('total'))}
							<span style={{ fontSize: '16px', color: '#4a4f55', paddingLeft: '5px' }}>
								{t('currency_unit')}
							</span>
						</Typography>
					</ListFiedGrid>
				</Block>

				<Grid container justify="flex-end" style={{ marginTop: '20px' }}>
					<Button variant="outlined" style={{ marginRight: '20px' }} onClick={goBack}>
						{'修改託運單'}
					</Button>
					<Button variant="contained" color="primary" onClick={onConfirm}>
						{t('payment_comfirm')}
					</Button>
				</Grid>

				<Block title={t('outbound_detail')}>
					{shippingOrderData.get('storageOrderItem').map(wineId => {
						const wineData = storageOrderItems.filter(item => item.id === wineId)[0]
						return (
							<Grid key={wineData.code} item container xs={3} direction="column">
								<Grid item
									className="wine-img"
									style={{
										backgroundImage: `url(${wineData.imageUrl})`,
									}}
								/>
								<Grid item>
									<Typography className="text-center text-grey">
										{wineData.code}
									</Typography>
								</Grid>
							</Grid>
						)
					})}
				</Block>
			</Grid>
			<CreateOrderResultDialog
				open={createOrderDialog}
				onClose={onCloseDialog}
				errorCode={errorCode}
			/>
		</Grid>
	)
}

const mapStateToProps = state => ({
	shippingCart: state.orders.shippingCart,
	memberInfo: state.member.member,
	orderCreditCardPaymentSucc: state.orders.orderCreditCardPaymentSucc,
	orderCreditCardPaymentFail: state.orders.orderCreditCardPaymentFail,
	shippingOrderData: state.orders.shippingOrderData,
	createShippingOrderFail: state.orders.createShippingOrderFail,
	errorCode: state.orders.errorCode,
})

const mapDispatchToProps = {
	createShippingOrder,
	orderCreditCardPayment,
	cleanOrderCreditCardPaymentResult,
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(PaymentComfirm))
